import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../assets/flexbox-helpers.scss';

export const templateCompanySelector = document.createElement('template');

templateCompanySelector.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-dropdown id="companySelectorDropdown" combobox class="dashboard-header--item"></gz-dropdown>
  </div>
`;
